/*
 * LegalPlace's default values setter
 */

import { isNull } from 'util';
import lpApp from '../app/lp_app';
import ConditionsEvo from './condition_evo';
import { checkRadio1 } from '../redux/actions/output';
import { lpIdGetPure } from './global_getter';
import { editedDocument } from '../redux/actions/account_settings';

class _DefaultValues {
  setDefaults(excludeCurrent = false) {
    // Getting sections to be treated
    let { currentSection } = lpApp.store.getState().contract;
    if (excludeCurrent) currentSection -= 1;

    // Reading through sections
    for (let i = 0; i <= currentSection; i += 1) {
      const sectionId = lpApp.store.getState().contract.sections[i].id;
      const section = lpApp.references.getSection(sectionId - 1);

      // Setting section's defaults
      section.options.map(id => this.setOptionDefault(id));
    }
  }

  setOptionDefault(id, copy = false) {
    const ref = lpApp.references.getOption(id);
    const eligibleId = (copy === false) ? id : `${id}_${copy}`;

    // Making sure reference is a valid option with a valid meta
    if (typeof ref !== 'object' || typeof ref.meta !== 'object') return;

    // If type isn't a static/radio/checkbox we stop here
    if (!['static', 'radio', 'checkbox'].includes(ref.meta.type)) return;

    // Making sure option is true if it's conditional
    if (ref.meta.conditional && ConditionsEvo.getCondition(eligibleId) !== true) return;

    // Getting radio children
    const eligibleChildren = [];
    ref.children.map((id) => {
      const childRef = lpApp.references.getOption(id);

      // Making sure reference is a valid option with a valid meta
      if (typeof childRef !== 'object' || typeof childRef.meta !== 'object') return id;

      // If type isn't a radio we stop here
      if (childRef.meta.type !== 'radio') return id;

      let eligibleId = (copy === false) ? id : id + '_' + copy;
      eligibleChildren.push(eligibleId);

      return id;
    });

    // Getting option's default & current value
    let defaultValue = parseInt(ref.meta.default, 10) ? ref.meta.default : 0;
    let currentValue = null;
    eligibleChildren.map((id) => {
      if (lpApp.indexes.options.getOption(id).value === true) currentValue = id;
      return id;
    });

    // If default value isn't set we asume the first option is the default
    // value in case the auto default is enabled
    if ((defaultValue === "0" || defaultValue === 0)
      && !lpApp.store.getState().contract.disable_auto_default
      && eligibleChildren.length > 0
    ) {
      [defaultValue] = eligibleChildren;
    }

    // Setting default value if it's superior to 0 and current value is null
    if (isNull(currentValue) && defaultValue > 0) {

      eligibleChildren.map((id) => {
        lpApp.indexes.updateOption({
          id,
          value: (lpIdGetPure(id) === defaultValue),
        });
        return id;
      });
      lpApp.store.dispatch(checkRadio1(defaultValue + (copy ? `_${copy}` : ''), eligibleId));
      lpApp.store.dispatch(editedDocument(true));
      currentValue = copy ? `${defaultValue}_${copy}` : defaultValue;
    }

    // Checking children
    ref.children.map((cId) => {
      const cRef = lpApp.references.getOption(cId);
      const contractId = (copy === false) ? cId : `${cId}_${copy}`;

      // If type isn't a static/radio/checkbox we stop here
      if (!['static', 'radio', 'checkbox'].includes(cRef.meta.type)) return cId;

      // If it's a radio and it's not checked we stop here
      if (cRef.meta.type === 'radio' && contractId !== currentValue) return cId;

      // If it's a checkbox and it's not checked we stop here
      if (cRef.meta.type === 'checkbox' && lpApp.indexes.options.getOption(contractId).value !== true) return cId;

      // Making sure option is true if it's conditional
      if (cRef.meta.conditional && ConditionsEvo.getCondition(contractId) !== true) return cId;

      // Checking for defaults
      this.setOptionDefault(cId, copy);

      return cId;
    });

    // If option is multiple & has other indexes, we fire them
    if (ref.meta.multiple === true && lpApp.indexes.multiples.getMultiple(id) && copy === false) {
      lpApp.indexes.multiples.getMultiple(id).map((multiple) => {
        this.setOptionDefault(id, multiple);
        return multiple;
      });
    }
  }
}

const DefaultValues = new _DefaultValues();
export default DefaultValues;



// WEBPACK FOOTER //
// ./src/logic/default_values.js